import React, { useMemo } from 'react'

import {
  useAddIncidentForm,
  useEventTypes,
  usePalmettoIncidents,
} from '../hooks'

import Button, { BUTTON_STYLES } from '../../common/components/Button'
import TextInput from '../../common/components/TextInput'
import Select from '../../common/components/Select'

import styles from './AddIncidentForm.module.css'

const AddIncidentForm = () => {
  const [
    { title, eventType, incident, validationErrors },
    { send, close, setEventType, setTitle, setIncident },
  ] = useAddIncidentForm()
  const eventTypes = useEventTypes()
  const palmettoIncidents = usePalmettoIncidents()

  const eventTypeOptions = useMemo(() => {
    const defaultOption = { label: 'Select an Event Type', value: '' }
    const opts = eventTypes.map((t) => ({ label: t, value: t }))
    return [defaultOption, ...opts]
  }, [eventTypes])

  const incidentOptions = useMemo(() => {
    const defaultOption = { label: 'Select an Incident', value: -1 }
    const opts = palmettoIncidents.map((i) => ({
      label: i.pvIncidentName,
      value: i.pvIncidentName,
    }))
    return [defaultOption, ...opts]
  }, [palmettoIncidents])

  return (
    <div className={styles.container}>
      <div className={styles.header}>Send Incident To Palmetto</div>

      <TextInput label="Title" value={title} onChange={setTitle} />
      <Select
        label="Event Type"
        value={eventType}
        options={eventTypeOptions}
        onChange={setEventType}
      />
      <Select
        label="Incident"
        value={incident}
        onChange={setIncident}
        options={incidentOptions}
      />
      {validationErrors.length > 0 && (
        <ul style={{ listStyle: 'none', color: 'red' }}>
          {validationErrors.map((err, i) => (
            <li key={i}>{err}</li>
          ))}
        </ul>
      )}
      <div className={styles.footer}>
        <Button
          onClick={close}
          className={styles.button}
          text="Cancel"
          style={BUTTON_STYLES.SECONDARY}
        />
        <Button
          onClick={send}
          text="Send"
          style={BUTTON_STYLES.PRIMARY}
          disabled={!title}
        />
      </div>
    </div>
  )
}

export default AddIncidentForm
